import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './styles/globals.css';
import './styles/components.css';
import { validateAndClearInvalidTokens } from './utils/clearAuth';

// Clear invalid tokens on app startup
validateAndClearInvalidTokens();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
